import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SupplierService } from 'src/app/shared/services/supplier.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Languages } from 'src/app/shared/models/enums.model';
import { SupplierDTOForRAting } from 'src/app/shared/models/e-tender.model';
//import { forEach } from '@angular/router/src/utils/collection';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-supplier-rating',
  templateUrl: './supplier-rating.component.html',
  styleUrls: ['./supplier-rating.component.css']
})
export class SupplierRatingComponent implements OnInit {
  supplierId: string;
  displayedLang: string;
  suppinfo: string;
  model: SupplierDTOForRAting;
  listRating: any[] = [];
  listIds: number[] = [];
  rating: number;
  showRatedRequest: boolean;
  ratingObj = {};
  submited: boolean = false;
  currentUser: string;
  constructor(private route: ActivatedRoute, private supplierService: SupplierService, private alertService: AlertService,
    private translate: TranslateService, private global: GlobalServices, private authSrevice: AuthenticationService) {
    this.supplierId = this.route.snapshot.params.Id;
    this.displayedLang = this.global.getLanguage() == Languages.Arabic ? 'ar' : 'en';
    this.currentUser = this.authSrevice.currentUserValue.Email;
    //this.currentUser = this.global.user.Email;
  }

  ngOnInit() {
    this.getSupplierInfo();
  }
  // get supplierinfo for rating
  getSupplierInfo() {
    this.supplierService.GetSupplierForRating(this.supplierId, this.displayedLang, this.currentUser).subscribe(
      d => {

        this.model = d.Data;

      }
    )

  }

  rateSpeciality(rate) {

    rate.forEach(elm => {
      if (elm.Rating == null) {
        return;
      }

    });


    // rate.forEach(elm => {

    //   // this.rating = rate.Rating[elm];
    //   let ratevalue = elm.Rating;
    //   let idVAlue = elm.Id;
    //   var obj = {
    //     Rating: ratevalue,
    //     Id: idVAlue

    //   };
    //   this.listRating.push(obj);
    //   //this.listIds.push(idVAlue);
    // });

    this.supplierService.RateSupplierSpeciality(this.supplierId, this.ratingObj).subscribe(
      d => {
        if (d.Success) {
          this.showRatedRequest = true;
        } else {
          this.showRatedRequest = false;
          this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + d.ErrorMessages[0]));

        }
      }
    );

  }

  setRating(id, value) {
    this.ratingObj[id] = value;
  }

}
